import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { lastValueFrom } from 'rxjs';
import { environment } from '../../../../environments/environment';
import { AuditRecord, ClientSnapshot, GroupedAuditRecord, LatestPerFieldMap } from '../../models/audit.model';

@Injectable({
  providedIn: 'root',
})
export class AuditService {
  private readonly base = `${environment.apiUrl}/client-audit`;

  constructor(private http: HttpClient) {}

  async getClientHistory(
    clientId: number,
    options?: { dateTo?: Date; entityType?: string; page?: number; limit?: number },
  ): Promise<{ records: GroupedAuditRecord[]; total: number }> {
    let params = new HttpParams();
    if (options?.dateTo) {
      params = params.set('dateTo', options.dateTo.toISOString());
    }
    if (options?.entityType) {
      params = params.set('entityType', options.entityType);
    }
    if (options?.page) {
      params = params.set('page', String(options.page));
    }
    if (options?.limit) {
      params = params.set('limit', String(options.limit));
    }
    return lastValueFrom(
      this.http.get<{ records: GroupedAuditRecord[]; total: number }>(
        `${this.base}/${clientId}`,
        { params },
      ),
    );
  }

  async getLatestPerField(
    clientId: number,
    entityType?: string,
    entityId?: number,
  ): Promise<LatestPerFieldMap> {
    let params = new HttpParams();
    if (entityType) {
      params = params.set('entityType', entityType);
    }
    if (entityId !== undefined) {
      params = params.set('entityId', String(entityId));
    }
    return lastValueFrom(
      this.http.get<LatestPerFieldMap>(
        `${this.base}/${clientId}/latest-per-field`,
        { params },
      ),
    );
  }

  async getClientSnapshot(clientId: number, date: Date): Promise<ClientSnapshot> {
    const params = new HttpParams().set('date', date.toISOString());
    return lastValueFrom(
      this.http.get<ClientSnapshot>(`${this.base}/${clientId}/snapshot`, { params }),
    );
  }
}
